export const newsTableOption = {
  page:false,
  border: true,
  stripe: true,
  align:'center',
  menuAlign:'center',
  delBtn: false,
  editBtn: false,
  addBtn: false,
  searchShow: false,
  searchBtn: false,
  column: [{
    label: '标题 ',
    prop: 'title',
    align: 'center',
    width: 540,
  }, {
    label: '标签',
    prop: 'tagName',
    align: 'center',
    width: 240,
  },
  {
      label: '来源',
      prop: 'sourceName',
      align: 'center',
      width: 180,
  },
  {
      label: '收藏',
      prop: 'favoriteCount',
      // sortable: true,
      align: 'center',
      width: 110,
  },
  {
      label: '状态',
      prop: 'status',
      align: 'center',
      width: 110,
  }, {
    // type: 'datetime',
    // valueFormat: 'timestamp',
    // format: 'yyyy-MM-dd hh:mm:ss',
    label: '发布时间',
    prop: 'publishDate',
    width: 180,
    sortable: true,
    align: 'center'
  }]
}

export const sourceTableOption = {
  page:false,
  border: true,
  stripe: true,
  align:'center',
  menuAlign:'center',
  delBtn: false,
  editBtn: false,
  addBtn: false,
  searchShow: false,
  searchBtn: false,
  column: [{
    label: '来源名称',
    prop: 'name',
    align: 'center',
    width: 300,
  },{
    label: '来源类型',
    prop: 'sourceType',
    align: 'center',
    width: 150,
  },{
    label:'爬取状态',
    width: 100,
    type:'select',
    prop:'isActive2',
    solt: true,
    span:24,
    dicData: [{
      label: '关闭',
      value: false
    }, {
      label: '开启',
      value: true
    }]
  },{
    label:'展示结果',
    width: 100,
    type:'select',
    prop:'isDisplay2',
    solt: true,
    span:24,
    dicData: [{
      label: '否',
      value: false
    }, {
      label: '是',
      value: true
    }]
  },{
    label: '',
    prop: '',
    align: 'center',
    width: 600,
  }]
}